import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Reveal } from '@/components/motion/Reveal';
import { Shield, ArrowRight } from 'lucide-react';

export const FinalCTASection = () => {
  return (
    <section className="relative overflow-hidden bg-midnight-green text-ivory">
      {/* Warm gradient wash */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(70% 60% at 85% 0%, hsl(var(--copper) / 0.18), transparent 60%), radial-gradient(60% 60% at 0% 100%, hsl(var(--deep-teal) / 0.45), transparent 60%)',
        }}
      />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <Reveal>
              <span className="eyebrow text-copper/90">Ready when you are</span>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="font-display text-display-lg text-ivory mt-6 text-balance">
                From wilderness to dining hall —{' '}
                <span
                  className="italic text-copper"
                  style={{ fontVariationSettings: '"opsz" 144, "SOFT" 100' }}
                >
                  let CampChef Pro be your kitchen's north star.
                </span>
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-4">
            <Reveal delay={160}>
              <div className="flex flex-col gap-5 lg:border-l lg:border-ivory/15 lg:pl-8">
                {[
                  { k: '5 min', v: 'Setup time' },
                  { k: '99.7%', v: 'Uptime reliability' },
                  { k: '40-80 hrs', v: 'Monthly time saved' },
                ].map((s) => (
                  <div key={s.k} className="flex items-baseline gap-4">
                    <span className="font-display text-3xl text-copper tabular-nums">{s.k}</span>
                    <span className="font-inter text-sm text-ivory/70">{s.v}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={240}>
          <div className="mt-14 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-ivory/10 pt-10">
            <Button
              asChild
              size="lg"
              className="bg-copper hover:bg-copper/90 text-ivory font-medium text-base px-7 h-12 btn-press shadow-editorial"
            >
              <Link to="/contact" className="inline-flex items-center gap-2">
                Request a camp demo <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
            <Link
              to="/contact"
              className="story-link font-inter text-ivory/85 hover:text-ivory text-base font-medium"
            >
              Talk to sales
            </Link>
            <span className="ml-auto inline-flex items-center gap-2 text-ivory/55 text-xs uppercase tracking-[0.18em]">
              <Shield className="h-3.5 w-3.5" /> Secure sync. Works offline.
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
